import React from 'react';
import { Box, Image, Text as ChakraText } from '@chakra-ui/react';
import { useSiteConfig } from '../../context/SiteConfigContext';

const CircularLogo = ({ size = 120 }) => {
  const { config } = useSiteConfig();
  const darkRed = '#620404';
  const white = '#ffffff';

  return (
    <Box
      position="relative"
      w={`${size}px`}
      h={`${size}px`}
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={10}
      overflow="visible"
      borderRadius="full"
      border={`${size * 0.03}px solid ${darkRed}`}
      bg={white}
      boxShadow="0 4px 15px rgba(0, 0, 0, 0.4)"
    >
      <Image
        src={config.logo || '/images/logo.png'}
        alt="Temple Logo"
        w="100%"
        h="100%"
        objectFit="cover"
        borderRadius="full"
        fallback={
          <ChakraText fontSize={`${size * 0.3}px`}>🕉️</ChakraText>
        }
      />
    </Box>
  );
};

export default CircularLogo;

